import { render, staticRenderFns } from "./ContentNavabar.vue?vue&type=template&id=236a74ca&scoped=true"
import script from "./ContentNavabar.vue?vue&type=script&lang=ts"
export * from "./ContentNavabar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a74ca",
  null
  
)

export default component.exports